import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router/dom';
import { CircularProgress, Stack, ThemeProvider } from '@mui/material';
import { useAuthStore } from '@store/authStore';
import { router } from './routes';
import { useAppTheme } from '@theme/useTheme';
import { initClarity } from '@services/clarity';
import { supabase } from '@lib/supabase';

export default function App() {
  const { checkSession } = useAuthStore();
  const theme = useAppTheme();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        // Initialize Clarity tracking
        initClarity();
      } catch (error) {
        console.warn('Failed to initialize Clarity:', error);
      }

      // Check authentication session
      checkSession();

      // Mark as initialized
      setIsInitialized(true);
    };

    initialize();

    // Listen for auth state changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('Auth state change:', event, session?.user?.id);
      // Skip loading state for auth state changes to prevent flickering
      checkSession(true);
    });

    return () => subscription.unsubscribe();
  }, [checkSession]);

  // Show simple loading indicator while initializing
  if (!isInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <Stack
          sx={{
            height: '100dvh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Stack>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}
